import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import Footer from '@/Component/Footer';
import Header from '@/Component/Header';
import RenderIf from '@/Component/RenderIf';
import KinetekLoader from '@/Component/KinetekLoader';

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const router = useRouter();

  const [isPageLoader, setIsPageLoader] = useState<boolean>(false);

  const buttonNames = useMemo(() => {
    if (router.asPath.includes('faq')) {
      return 'To homepage';
    }

    return 'To the mint';
  }, [router]);

  useEffect(() => {
    const handleStart = () => setIsPageLoader(true);
    const handleComplete = () => setIsPageLoader(false);
    const handleError = () => setIsPageLoader(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleError);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleError);
    };
  }, [router, setIsPageLoader]);

  return (
    <div>
      <Header buttonName={buttonNames} headerText="Kinetek" />
      {children}
      <RenderIf condition={isPageLoader}>
        <KinetekLoader />
      </RenderIf>
      <Footer />
    </div>
  );
};

export default AppLayout;
